import React from 'react'

import * as S from './styles'
import { Text } from '../text'

export type TestimonialProps = {
  /**
   * Picture included in testimonial
   * @example
   * ```tsx
   * <Testimonial authorPicture='/image' />
   * ```
   * */
  authorPicture: string

  /**
   * Name of the author
   * @example
   * ```tsx
   * <Testimonial authorName='John Doe' />
   * ```
   * */
  authorName: string

  /**
   * Role of the author to be displayed
   * @example
   * ```tsx
   * <Testimonial authorRole='CEO' />
   * ```
   * */
  authorRole: string

  /**
   * Text of the testimonial
   * @example
   * ```tsx
   * <Testimonial description='lorem ipsum' />
   * ```
   * */
  description: string

  /**
   * Dark Mode
   * @example
   * ```tsx
   * <Testimonial darkMode={true} />
   * ```
   * */
  darkMode?: boolean
}

export const Testimonial: React.FC<TestimonialProps> = ({
  authorPicture,
  authorName,
  authorRole,
  description,
  darkMode,
}) => (
  <S.TestimonialContainer darkMode={darkMode}>
    <S.AvatarSide className="author-picture" src={authorPicture} alt="author" />

    <S.ContentContainer>
      <S.AuthorContainer>
        <S.AvatarTop src={authorPicture} alt="author" />

        <div>
          <Text size="b1" className="author-name testimonial-text">
            {authorName}
          </Text>
          <Text size="b3" className="author-role testimonial-text">
            {authorRole}
          </Text>
        </div>
      </S.AuthorContainer>

      <Text size="b3" className="case-description testimonial-text">
        {description}
      </Text>
    </S.ContentContainer>
  </S.TestimonialContainer>
)
